webpackJsonp([60914776476172],{

/***/ 2141:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LabOrderDetail","kind":"UNION","type":"OBJECT","fields":null,"description":"Integration-specific details for a lab order.","enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"FujirisLabOrderDetail","ofType":null},{"kind":"OBJECT","name":"HarvestLabOrderDetail","ofType":null}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---union-lab-order-detail-c696b5fa4cb5f96f08db.js